export const routes = {
  homePage: '/',
  specificUser: '/user/:id',
  addUser: '/add_user',
}
